import React, { useEffect, useState } from 'react'
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material'
import QRCode from 'react-qr-code'
import dateFormat, { masks } from "dateformat";
import { PDFDownloadLink } from "@react-pdf/renderer";
import QRGenerator from '../../../components/QRGenerator';
import TicketComponent from '../../../components/TicketComponent';
import logoMsamp from "../../../assets/logo_msanp2.png"
import { Link, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { database } from '../../../firebaseConfig';

function Ticket() {
    const route = useParams()
    const id = route.id
    const [loading,setLoading]=useState(false)
    const [reservation, setReservation] = useState({})
    useEffect(() => {
        const fetchReservation = async () => {
            setLoading(true)
            const reservationDoc = doc(database, 'reservation', id)
            const reservationDocRef = await getDoc(reservationDoc)
            const chuDoc = doc(database, 'chu', reservationDocRef.data().chu_id)
            const serviceDoc = doc(database, 'service', reservationDocRef.data().service_id)
            const chuDocRef = await getDoc(chuDoc)
            const serviceDocRef = await getDoc(serviceDoc)
            const reservationData = {
                reference: reservationDocRef.data().reference,
                service: serviceDocRef.data().nom_service,
                chu: chuDocRef.data().nom_chu,
                date: dateFormat(new Date(reservationDocRef.data().date_rdv), "dd/mm/yyyy"),
                heure_rdv: reservationDocRef.data().heure_rdv,
                nom: reservationDocRef.data().nom,
                prenom: reservationDocRef.data().prenom,
                contact: reservationDocRef.data().contact,
                contact_chu: chuDocRef.data().contact_chu,
                email_chu: chuDocRef.data().email_chu,
                lieu: chuDocRef.data().lieu,
                logo: chuDocRef.data().logo_chu,
            }
            console.log(reservationData)
            setReservation(reservationData)
            setLoading(false)
        };

        fetchReservation().catch(error => {
            console.error("Erreur lors de la récupération de la réservation:", error);
        });
        

    }, [id])
    if (!reservation.reference) {
        return (
            <div></div>
        )
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center' }}>
            <Typography variant='h5' >
                Votre prise de <b>RENDEZ-VOUS</b> a été effectuée avec succès.
            </Typography>
            <br />
            <img src={require('../../../assets/successImg.png')} style={{ width: '100px', height: '100px' }} />
            <br />
            <Typography variant='subtitle1' >
                Ci-joint, veuillez trouver votre pièce justificative.<br /> Nous vous remercions de bien vouloir conserver ce ticket et de l'apporter lors de votre <b>RENDEZ-VOUS</b>.
            </Typography>
            <br />
            <Card sx={{ width: { md: '40%', sm: '40%', xs: '80%' } }}>
                <CardContent style={{ textAlign: 'center' }}>
                    <Typography variant='subtitle1'><u><b>TICKET</b></u></Typography>
                    <QRGenerator value={reservation.reference.toString()} documentId={reservation.reference} />
                    <Typography variant='subtitle1'><b><u>Numéro de référence</u>:</b> {reservation.reference} </Typography>
                </CardContent>
            </Card>
            <CardActions style={{ justifyContent: 'space-between' }}>
                <Button component={Link} to="/admin/addReservation" variant='contained' size='small' color='error' sx={{ textTransform: "none", }}>Retour</Button>
                <PDFDownloadLink document={<TicketComponent data={reservation} />} fileName={`rdv_${dateFormat(new Date(), 'yyyymmddHHMMss')}.pdf`}>
                    <Button variant='contained' size="small"
                        sx={{
                            textTransform: "none", bgcolor: 'rgb(1,166,1)', border: '1px solide rgb(1,166,1)', ":hover": {
                                bgcolor: 'rgb(1,127,1)'
                            }
                        }}>
                        Télecharger
                    </Button>
                </PDFDownloadLink>
            </CardActions>
        </div>
    )
}

export default Ticket